import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { getLocalStorageValue, setLocalStorageValue } from "./useLocalStorage";
import { v4 as uuid } from "uuid";
import { useAuth } from "../context/AuthContext";

const useUserInfoAndLogging = () => {
  const { user } = useAuth();
  const appInsights = useAppInsightsContext();
  const enabled = !!appInsights;

  const getAccountId = (): string => {
    return user!.id ?? "";
  };

  const getSessionId = (): string => {
    let sessionId = getLocalStorageValue("sessionId", undefined);
    if (!sessionId) {
      sessionId = uuid();
      setLocalStorageValue("sessionId", sessionId);
    }
    return sessionId;
  };

  const logMetric = (name: string, action: string): void => {
    if (!enabled) {
      return;
    }

    try {
      const metricData = {
        average: 1,
        name: name,
        sampleCount: 1,
      };
      const additionalData = {
        "Account Id": getAccountId(),
        "Session Id": getSessionId(),
        Action: action,
      };
      appInsights.trackMetric(metricData, additionalData);
    } catch (err) {
      console.log(err);
    }
  };

  const logException = (error: any): void => {
    if (!enabled) {
      return;
    }
    console.log(error);
    try {
      const exceptionData = {
        error: new Error(error),
        severityLevel: SeverityLevel.Error,
      };
      const additionalData = {
        "Account Id": getAccountId(),
        "Session Id": getSessionId(),
      };
      appInsights.trackException(exceptionData, additionalData);
    } catch (err) {
      console.log(err);
    }
  };

  return {
    getAccountId,
    getSessionId,
    logMetric,
    logException,
  };
};

export default useUserInfoAndLogging;
